import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import ActionButtons from '../components/ActionButtons';
import Header from '../components/Header';
import Loader from '../components/Loader';
import { fields, LOCAL_STORAGE_KEY } from '../constants';
import { getDetailsApi } from '../utils/api';
import { mergeLookupDetails } from '../utils/lookupDetails';
import { randomNumber } from '../utils/helper';
const Haryana = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  const history = useHistory();
  const state = 'haryana';

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: '',
    chassisNo: '',
    mobileNo: '',
    seatingCapacityExcludingDriver: '',
    borderBarrier: '',
    totalAmount: '',
    ownerName: '',
    fromState: '',
    vehicleClass: '',
    serviceType: '',
    taxMode: '',
    taxFromDate: '',
    taxUptoDate: '',
    distance: '',
    grossVehicleWeight: '',
    unladenWeight: '',
    vehicleType: '',
    vehicleCategory: '',
    checkpostName: '',
    mvTax: '',
    fitnessValidity: '',
    puccValidity: '',
    insuranceValidity: '',
    permitType: '',
  });
  // all inputs fields
  const [isLoading, setIsLoading] = useState(false);
  const form = useRef(null);

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert('Please enter vehicle no.');
      return;
    }

    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const onChangeHandler = (e) => {
    setPayLoad((old) => {
      const updates = { [e.target.name]: e.target.value };
      if (e.target.name === 'vehicleType') {
        updates.vehicleClass = '';
        updates.vehicleCategory = '';
      }
      if (e.target.name === 'vehicleClass') {
        updates.vehicleCategory = '';
      }
      return { ...old, ...updates };
    });
  };

  useEffect(() => {
    setPayLoad((prev) => ({
      ...prev,
      totalAmount: prev.mvTax || "",
    }));
  }, [payLoad.mvTax]);

  // Vehicle Class Options
  const vehicleClassOptions = useMemo(() => {
    if (payLoad.vehicleType === "TRANSPORT") {
        return [
          "MOTOR CYCLE/SCOOTER",
          "CONSTRUCTION EQUIPMENT VEHICLE",
          "THREE WHEELER (PASSENGER)",
          "MOTOR CAB",
          "BUS",
          "EDUCATIONAL INSTITUTION BUS",
          "OMNI BUS",
          "SEMI-TRAILER (COMMERCIAL)",
          "CONSTRUCTION EQUIPMENT VEHICLE (COMMERCIAL)",
          "Modular Hydraulic Trailer",
          "ARTICULATED VEHICLE",
          "GOODS CARRIER",
          "PRIVATE SERVICE VEHICLE",
          "MAXI CAB"
        ];
    }
    if (payLoad.vehicleType === "NON-TRANSPORT") {
        return ["CRANE MOUNTED VEHICLE"];
    }
    return [];
  }, [payLoad.vehicleType]);

  // Vehicle Category Options
  const vehicleCategoryOptions = useMemo(() => {
    const cls = payLoad.vehicleClass;
    if (!cls) return [];
    
    // Passenger classes
    const passenger = [
      "MOTOR CYCLE/SCOOTER",
      "THREE WHEELER (PASSENGER)",
      "MOTOR CAB",
      "BUS",
      "EDUCATIONAL INSTITUTION BUS",
      "OMNI BUS",
      "PRIVATE SERVICE VEHICLE",
      "MAXI CAB"
    ];
    
    // Goods classes
    const goods = [
      "CONSTRUCTION EQUIPMENT VEHICLE",
      "SEMI-TRAILER (COMMERCIAL)",
      "CONSTRUCTION EQUIPMENT VEHICLE (COMMERCIAL)",
      "Modular Hydraulic Trailer",
      "ARTICULATED VEHICLE",
      "GOODS CARRIER"
    ];

    if (payLoad.vehicleType === "NON-TRANSPORT") {
      return ["HEAVY MOTOR VEHICLE"];
    }

    if (passenger.includes(cls)) {
      return ["LIGHT PASSENGER VEHICLE", "MEDIUM PASSENGER VEHICLE", "HEAVY PASSENGER VEHICLE"];
    }
    
    if (goods.includes(cls)) {
      return ["LIGHT GOODS VEHICLE", "MEDIUM GOODS VEHICLE", "HEAVY GOODS VEHICLE"];
    }
    
    return [];
  }, [payLoad.vehicleClass, payLoad.vehicleType]);


  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!payLoad.unladenWeight) {
      payLoad.unladenWeight = 0;
    }
    payLoad.bankRefNo = randomNumber(8);
    history.push('/select-payment', {
      formData: {
        ...payLoad,
        state,
      },
    });
  };

  const onResetHandler = () => {
    let x = { ...payLoad };
    let p = {};
    Object.keys(x).forEach((e) => {
      p[e] = '';
    });
    setPayLoad({ ...p });
  };

  if (
    !isLoggedIn ||
    !isLoggedIn.accessState ||
    !isLoggedIn.accessState.includes(fields.stateName.haryana)
  ) {
    return (
      <>
        <Header />
        <div className='container text-center mt-4 '>
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }
  return (
    <>
      <Header />
      <div className='text-center'>
        <p className='login-heading mt-4'>
          <b>BORDER TAX PAYMENT FOR ENTRY INTO</b> <span>HARYANA</span>
        </p>
      </div>
      <div className='box box--main'>
        <div className='box__heading--blue'>Tax Payment Details</div>
        <form
          ref={form}
          onSubmit={onSubmitHandler}
          className='service-type tax-details mt-4'
        >
          <div className='row'>
            <div className='col-6'>
              {/* <!-- vehicle number --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='vehicleNo'
                >
                  Vehicle No.<sup>*</sup>
                </label>
                <input
                  tabIndex='1'
                  required
                  inputMode='text'
                  disabled={isLoading}
                  maxLength='10'
                  autoFocus
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className='form__input w-100'
                  type='text'
                  id='vehicleNo'
                  name='vehicleNo'
                />
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  {/* <!-- chassis number --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='chassisNo'
                    >
                      Chassis No.<sup>*</sup>
                    </label>
                    <input
                      tabIndex='2'
                      required
                      maxLength='19'
                      inputMode='text'
                      disabled={isLoading}
                      onChange={onChangeHandler}
                      value={payLoad.chassisNo}
                      className='form__input w-100'
                      type='text'
                      id='chassisNo'
                      name='chassisNo'
                    />
                  </div>
                </div>
                <div className='col-sm-6'>
                  {/* <!-- mobile number --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='mobileNo'
                    >
                      Mobile No.<sup>*</sup>
                    </label>
                    <input
                      tabIndex='3'
                      required
                      disabled={isLoading}
                      placeholder='SMS about payment will be sent to this number '
                      className='form__input w-100'
                      type='text'
                      id='mobileNo'
                      inputMode='tel'
                      value={payLoad.mobileNo}
                      onChange={onChangeHandler}
                      maxLength='10'
                      minLength='10'
                      name='mobileNo'
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  {/* <!-- owner name --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='ownerName'
                    >
                      Owner Name<sup>*</sup>
                    </label>
                    <input
                      tabIndex='8'
                      required
                      disabled={isLoading}
                      inputMode='text'
                      className='form__input w-100'
                      type='text'
                      id='ownerName'
                      name='ownerName'
                      onChange={onChangeHandler}
                      value={payLoad.ownerName}
                    />
                  </div>
                </div>
                <div className='col-sm-6'>
                  {/* <!-- from state --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='fromState'
                    >
                      From State<sup>*</sup>
                    </label>
<select
                      tabIndex='9'
                      required
                      disabled={isLoading}
                      value={payLoad.fromState}
                      onChange={onChangeHandler}
                      name='fromState'
                      id='fromState'
                    >
                      <option value=''>--Select State--</option>
                      {fields.fromState.map((type) => {
                        return (
                          <option value={String(type.name).toUpperCase()} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  {/* <!-- vehicle type --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='vehicleType'
                    >
                      Vehicle Type<sup>*</sup>
                    </label>
                    <select
                      tabIndex='3'
                      required
                      disabled={isLoading}
                      value={payLoad.vehicleType}
                      onChange={onChangeHandler}
                      name='vehicleType'
                      id='vehicleType'
                    >
                      <option value=''>--Select Vehicle Type--</option>
                      <option value='TRANSPORT'>TRANSPORT</option>
                      <option value='NON-TRANSPORT'>NON-TRANSPORT</option>
                    </select>
                  </div>
                </div>
                <div className='col-sm-6'>
                  {/* <!-- vehicle class --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='vehicleClass'
                    >
                      Vehicle Class<sup>*</sup>
                    </label>
                    <select
                      tabIndex='10'
                      disabled={isLoading}
                      required
                      value={payLoad.vehicleClass}
                      onChange={onChangeHandler}
                      name='vehicleClass'
                      id='vehicleClass'
                    >
                      <option value=''>--Select Vehicle Class--</option>
                      {vehicleClassOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  {/* <!-- Permit Type --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='permitType'
                    >
                      Permit Type<sup>*</sup>
                    </label>
                    <select
                      tabIndex='12'
                      required
                      disabled={isLoading}
                      value={payLoad.permitType}
                      onChange={onChangeHandler}
                      name='permitType'
                      id='permitType'
                    >
                      <option value=''>--Select Permit Type--</option>
                      {(fields.haryana.permitType || []).map((type) => {
                        return (
                          <option key={type.name} value={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              {payLoad.vehicleClass &&
               !["GOODS CARRIER", "CONSTRUCTION EQUIPMENT VEHICLE", "SEMI-TRAILER (COMMERCIAL)", "CONSTRUCTION EQUIPMENT VEHICLE (COMMERCIAL)", "Modular Hydraulic Trailer", "ARTICULATED VEHICLE", "CRANE MOUNTED VEHICLE"].includes(payLoad.vehicleClass) ? (
                <div className='row'>
                  <div className='col-sm-12'>
                    {/* <!-- seating capacity --> */}
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='seatingCapacityExcludingDriver'
                      >
                        Seating Capacity(Excluding Driver)<sup>*</sup>
                      </label>
                      <input
                        tabIndex='5'
                        required
                        inputMode='numeric'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className='form__input w-100'
                        type='number'
                        min='0'
                        value={payLoad.seatingCapacityExcludingDriver}
                        id='seatingCapacityExcludingDriver'
                        name='seatingCapacityExcludingDriver'
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className='row'>
                  <div className='col-sm-6'>
                    {/* <!-- gross vehicle wieght --> */}
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='grossVehicleWeight'
                      >
                        Gross Vehicle Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        tabIndex='5'
                        required
                        inputMode='numeric'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className='form__input w-100'
                        type='number'
                        min='0'
                        value={payLoad.grossVehicleWeight}
                        id='grossVehicleWeight'
                        name='grossVehicleWeight'
                      />
                    </div>
                  </div>
                  <div className='col-sm-6'>
                    {/* <!-- unladen Weight --> */}
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='unladenWeight'
                      >
                        Unladen Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        tabIndex='5'
                        required
                        inputMode='numeric'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className='form__input w-100'
                        type='number'
                        min='0'
                        value={payLoad.unladenWeight}
                        id='unladenWeight'
                        name='unladenWeight'
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className='row'>
                <div className='col-sm-12'>
                  {/* <!-- distance --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='distance'
                    >
                      Distance(In KM)<sup>*</sup>
                    </label>
                    <input
                      tabIndex='6'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='number'
                      min='0'
                      inputMode='numeric'
                      id='distance'
                      onChange={onChangeHandler}
                      name='distance'
                      value={payLoad.distance}
                    />
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-12'>
                  {/* <!-- Tax From Date --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='taxFromDate'
                    >
                      Tax From Date<sup>*</sup>
                    </label>
                    <input
                      tabIndex='13'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='datetime-local'
                      id='taxFromDate'
                      name='taxFromDate'
                      onChange={onChangeHandler}
                      value={payLoad.taxFromDate}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* ============  right side form fields ================== */}
            <div className='col-6'>
              <div className='form__control text-left'>
                <label className='form__label d-block w-100 text-left'>
                  &nbsp;
                </label>
                {isLoading && <Loader className='loader__get-details' />}
                {!isLoading && (
                  <button
                    disabled={isLoading}
                    type='button'
                    onClick={getDetailsHandler}
                    className='box__button get-details'
                  >
                    <span className='glyphicon glyphicon-arrow-down mr-3'></span>
                    Get Details
                  </button>
                )}
              </div>
              {/* <!-- service type --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='serviceType'
                >
                  Service Type<sup>*</sup>
                </label>
                <select
                  tabIndex='11'
                  disabled={isLoading}
                  required
                  value={payLoad.serviceType}
                  onChange={onChangeHandler}
                  name='serviceType'
                  id='serviceType'
                >
                  <option value=''>--Select Service Type--</option>
                  {fields.haryana.serviceType.map((type) => {
                    return <option key={type.name}>{type.name}</option>;
                  })}
                </select>
              </div>
              {/* <!-- Tax mode --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='taxMode'
                >
                  Tax Mode<sup>*</sup>
                </label>
                <select
                  tabIndex='12'
                  disabled={isLoading}
                  required
                  onChange={onChangeHandler}
                  value={payLoad.taxMode}
                  name='taxMode'
                  id='taxMode'
                >
                  <option value=''>--Select Tax Mode--</option>
                  {fields.taxMode.map((type) => {
                    return (
                      <option value={type.name} key={type.name}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* <!-- vehicle category (moved from left) --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='vehicleCategory'
                >
                  Vehicle Category<sup>*</sup>
                </label>
                <select
                  tabIndex='10'
                  disabled={isLoading}
                  required
                  value={payLoad.vehicleCategory}
                  onChange={onChangeHandler}
                  name='vehicleCategory'
                  id='vehicleCategory'
                >
                  <option value=''>--Select Vehicle Category--</option>
                  {vehicleCategoryOptions.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  {/* <!-- Border/barrier --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='borderBarrier'
                    >
                      District Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex='7'
                      value={payLoad.borderBarrier}
                      onChange={onChangeHandler}
                      name='borderBarrier'
                      id='borderBarrier'
                      disabled={isLoading}
                      required
                    >
                      <option value=''>--Select District/Barrier--</option>
                      {fields.haryana.borderBarrier.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className='col-sm-6'>
                  {/* <!-- Checkpost Name --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='checkpostName'
                    >
                      Checkpost Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex='7'
                      value={payLoad.checkpostName}
                      onChange={onChangeHandler}
                      name='checkpostName'
                      id='checkpostName'
                      disabled={isLoading}
                      required
                    >
                      <option value=''>--Select Checkpost--</option>
                      {fields.haryana.borderBarrier.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  {/* <!-- Fitness Validity --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='fitnessValidity'
                    >
                      Fitness Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='14'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='datetime-local'
                      id='fitnessValidity'
                      name='fitnessValidity'
                      value={payLoad.fitnessValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
                <div className='col-sm-6'>
                  {/* <!-- PUCC Validity --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='puccValidity'
                    >
                      PUCC Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='14'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='datetime-local'
                      id='puccValidity'
                      name='puccValidity'
                      value={payLoad.puccValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  {/* <!-- Insurance Validity --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='insuranceValidity'
                    >
                      Insurance Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='14'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='datetime-local'
                      id='insuranceValidity'
                      name='insuranceValidity'
                      value={payLoad.insuranceValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  {/* <!-- Tax upto Date --> */}
                  <div className='form__control'>
                    <label
                      className='form__label d-block w-100 text-left'
                      htmlFor='taxUptoDate'
                    >
                      Tax upto Date<sup>*</sup>
                    </label>
                    <input
                      tabIndex='14'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='datetime-local'
                      id='taxUptoDate'
                      name='taxUptoDate'
                      value={payLoad.taxUptoDate}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =============== table ======================== */}
          <div className='row mt-3'>
            <div className='col-12'>
              <table className='hr-table'>
                <thead>
                  <tr>
                    <th className='hr-table-1'>SI. No.</th>
                    <th className='hr-table-2'>Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='hr-table-body'>1</td>
                    <td className='hr-table-body'>MV Tax</td>
                    <td className='hr-table-body'>
                      {payLoad.taxFromDate
                        ? payLoad.taxFromDate.split("T")[0]
                        : ""}
                    </td>
                    <td className='hr-table-body'>
                      {payLoad.taxUptoDate
                        ? payLoad.taxUptoDate.split("T")[0]
                        : ""}
                    </td>
                    <td className='hr-table-body'>
                      <input
                        type='number'
                        className='form__input'
                        name='mvTax'
                        value={payLoad.mvTax}
                        onChange={onChangeHandler}
                        required
                        min='0'
                        inputMode='numeric'
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div className='row'>
            <div className='col-sm-6'>
              {/* <!-- Total amount --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='totalAmount'
                >
                  Total amount<sup>*</sup>
                </label>
                <input
                  tabIndex='15'
                  required
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.totalAmount}
                  className='form__input w-100'
                  type='text'
                  id='totalAmount'
                  name='totalAmount'
                />
              </div>
            </div>
            <div className='col-sm-6'>
              <label className='form__label d-block w-100 text-left'>
                &nbsp;
              </label>
              <ActionButtons
                tabIndex='16'
                isDisabled={isLoading}
                onReset={onResetHandler}
              />
            </div>
          </div>
        </form>
        <br />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Haryana;
